export class SaleViewModel {
    constructor() {

    }
}